module.exports = __webpack_public_path__ + "static/media/4656.c45729c2.jpg";